export default __webpack_public_path__ + "static/media/MEDTEC_LOGO.2f42e832.png";